(function() {
    'use strict';

    angular
        .module('pwc.controllers')
        .controller('PasswordResetController', PasswordResetController);

    PasswordResetController.$inject = ['$state', 'API', '$log', 'userPouch', '$analytics', '$mdToast', '$q', '$window', 'Utils'];

    /**
     * This controller handles resetting a password for a user that is NOT logged in.
     * They submitted their email and got a recovery link to here.
     *
     * @param API
     * @param $log
     * @constructor
     */
    function PasswordResetController($state, API, $log, userPouch, $analytics, $mdToast, $q, $window, Utils) {

        /* jshint validthis: true */
        var self = this;

        self.params = $state.params;

        self.state = {
            success: false,
            message: '',
            sending: false
        };

        self.username = $state.params.username;
        self.password = null;
        self.key = $state.params.key;

        self.submit = submit;
        self.login = login;

        /** begin methods */

        function submit(){

            self.state.sending = true;

            API.resetPassword(self.username, self.password, self.key).then(function(response) {

                $log.debug('API reset password response', response);

                self.state.success = true;

                self.login();

            }).catch(function(response){

                $log.error(response);

                self.state.message = response.data.error;

            }).finally(function(){

                self.state.sending = false;

            });

        }

        function login(){
            return userPouch
                .login(self.username, self.password)
                .catch(function(error) {
                    $log.debug('Error logging in', error);
                    self.state.message = error.message;

                    if (error.status === 401){
                        self.state.message += ' Username and password are case-sensitive. Please try again.';
                    }

                    if (error.status === 500){
                        self.state.message = 'Error logging in. Please check your internet connection and ensure it is active. Please also ensure you are NOT in private browsing / incognito mode. If the problem persists, please contact support@personalwinecurator.com.';
                    }

                    return $q.reject(error.message);
                })
                .then(function(response){
                    return userPouch.remote().getUser(self.username)
                        .catch(function(err){
                            $log.debug('err getting user meta', err);
                        });
                })
                .then(function(response){

                    var user = angular.fromJson(response);

                    $log.debug('Login complete', user);

                    $log.debug('Redirecting to wines');

                    $window._pq = $window._pq || [];

                    $window._pq.push(['track', 'Customer']);

                    $analytics.eventTrack('User Logged In');

                    Utils.go('wines');

                    $mdToast.show(
                        $mdToast.simple()
                            .content('Welcome back ' + lodash.get(user, 'metadata.billing.card.name', user.name) + '!')
                            .position("top right")
                            .hideDelay(5000)
                    );
                });
        }
    }

})();
